import styled from "styled-components";
import { LiveCasinoGridItemTitleDefaultBox } from "./live-casino-grid-item-title.default.box";

export const LiveCasinoGridItemTitleCasino777Box = styled(LiveCasinoGridItemTitleDefaultBox)`
    position: relative;
    background-color: ${props => props.theme.colors.buttonLight};
    color: ${props => props.theme.colors.buttonDark};
`;
